import { isomorphicCookies } from 'shared/storage'

export function isWebviewOnCookie() {
  const { isWebView } = isomorphicCookies.getAll()

  return isWebView === 'true'
}

export function isWebviewOnSearch() {
  const qs = new URLSearchParams(window.location.search)

  return qs.get('webview') === 'true'
}

export function isAndroidWebView() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  const isAndroid = userAgent.includes('android')

  return isAndroid && (userAgent.includes('wv') || /version\/\d+/.test(userAgent))
}

export function isIosWebView() {
  const userAgent = window.navigator.userAgent.toLowerCase()
  const isIos = /iphone|ipad|ipod/.test(userAgent)
  const isSafari = /safari/.test(userAgent) && !/crios|fxios/.test(userAgent)
  return isIos && (!isSafari || !/mobile\/.*safari/.test(userAgent))
}

export function isWebViewUserAgent(userAgent: string): boolean {
  const ua = userAgent.toLowerCase()
  const isAndroid = ua.includes('android') && (ua.includes('wv') || /version\/\d+/.test(ua))
  const isIos = /iphone|ipad|ipod/.test(ua) && !/safari/.test(ua)
  return isAndroid || isIos
}

export function detectClientIsWebView(): boolean {
  try {
    if (typeof window === 'undefined') return false

    return isWebviewOnCookie() || isWebviewOnSearch() || isAndroidWebView() || isIosWebView()
  } catch {
    return false
  }
}
